module.exports = __webpack_public_path__ + "static/media/Q_2_27.3d1cb5ab.png";